/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SsoCallbackMutationRequest,
  SsoCallbackMutationResponse,
  SsoCallback400,
} from '../types/SsoCallback'

function getSsoCallbackUrl() {
  const res = { method: 'POST', url: `/api/v1/auth/sso/callback/` as const }
  return res
}

/**
 * @description Handle OAuth callback and create user session.
 * Request body:
 * code: str - OAuth authorization code
 * state: str - State parameter for CSRF protection
 * Returns:
 * token: str - Django auth token
 * user: dict - User information
 * @summary Exchange an OAuth code for a session token
 * {@link /api/v1/auth/sso/callback/}
 */
export async function ssoCallback(
  data: SsoCallbackMutationRequest,
  config: Partial<RequestConfig<SsoCallbackMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    SsoCallbackMutationResponse,
    ResponseErrorConfig<SsoCallback400>,
    SsoCallbackMutationRequest
  >({
    method: 'POST',
    url: getSsoCallbackUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
